import React from 'react';
import ExtractionList from './ExtractionList';
import './ExtractionSidebar.css';

const ExtractionSidebar = ({ 
  extractions,
  currentExtractionId,
  onSelectExtraction,
  onCreateNewExtraction,
  formatTimestamp,
  getStatusLabel,
  getStatusClass,
  onClose
}) => {
  return (
    <div className="extraction-sidebar">
      <div className="sidebar-header">
        <button className="close-btn" onClick={currentExtractionId ? onClose : undefined}>
          ☰
        </button>
        <div>
          <h2>Extração de Pedidos</h2>
          <p>Histórico de Extrações</p>
        </div>
      </div>
      
      <ExtractionList
        extractions={extractions}
        currentExtractionId={currentExtractionId}
        onSelectExtraction={onSelectExtraction}
        formatTimestamp={formatTimestamp}
        getStatusLabel={getStatusLabel}
        getStatusClass={getStatusClass}
      />
    </div>
  );
};

export default ExtractionSidebar;
